import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./NewTopProject.css";
import img2 from "../../../Images/Group 7.png"
import HomeService from "../../../Services/HomeService";

const NewTopProject = () => {

  const [highlightedProjects, setHighlightedProjects] = useState([]);
  const sliderRef = useRef(null);

  const fetchHighlightedProject = async () => {
    try {
      const res = await HomeService?.getHighlightedProject();

      if (res?.status) {
        setHighlightedProjects(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchHighlightedProject();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 700,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: false,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="tpmodern-main-section">

      {/* BLUR EFFECTS */}

      <div className="tpmodern-blur-one"></div>
      <div className="tpmodern-blur-two"></div>

      <div className="tpmodern-container">

        {/* TOP */}

        <div className="tpmodern-top-wrapper">

          <div className="tpmodern-top-left">

            <span className="tpmodern-subtitle">
              Highlighted Projects
            </span>

            <h2 className="tpmodern-title">
              Discover premium investment opportunities crafted for future living
            </h2>

          </div>

          <div className="tpmodern-top-right">

            <p className="tpmodern-description">
              Explore handpicked real estate projects with modern architecture,
              premium amenities and prime city locations.
            </p>

            <div className="tpmodern-navigation">

              <button
                onClick={() => sliderRef.current.slickPrev()}
                className="tpmodern-nav-btn"
              >
                <i className="fa-solid fa-arrow-left"></i>
              </button>

              <button
                onClick={() => sliderRef.current.slickNext()}
                className="tpmodern-nav-btn"
              >
                <i className="fa-solid fa-arrow-right"></i>
              </button>

            </div>

          </div>

        </div>

        {/* SLIDER */}

        <div className="tpmodern-slider-wrapper">

          <Slider ref={sliderRef} {...settings}>

            {highlightedProjects?.map((p, i) => (

              <div className="tpmodern-slide-item" key={i}>

                <div className="tpmodern-project-card">

                  {/* IMAGE */}

                  <div className="tpmodern-image-wrapper">

                    <img
                      src={p?.image || img2}
                      alt={p?.title}
                      className="tpmodern-project-image"
                    />

                    <div className="tpmodern-image-overlay"></div>

                    <div className="tpmodern-tag">
                      Featured
                    </div>

                  </div>

                  {/* CONTENT */}

                  <div className="tpmodern-card-content">

                    <div className="tpmodern-content-top">

                      <div>

                        <h3 className="tpmodern-project-title">
                          {p?.title}
                        </h3>

                        <p className="tpmodern-project-description">
                          {p?.shortDescription}
                        </p>

                      </div>

                      <div className="tpmodern-price-box">
                        <span>Starting From</span>
                        <h4>{p?.price}</h4>
                      </div>

                    </div>

                    {/* DETAILS */}

                    <div className="tpmodern-details-grid">

                      <div className="tpmodern-detail-card">

                        <i className="fa-solid fa-building"></i>

                        <div>
                          <span>Property Type</span>
                          <p>
                            {p?.propertytype?.propertyType || "Luxury Apartment"}
                          </p>
                        </div>

                      </div>

                      <div className="tpmodern-detail-card">

                        <i className="fa-solid fa-location-dot"></i>

                        <div>
                          <span>Location</span>
                          <p>
                            {p?.city?.name || "Prime Location"}
                          </p>
                        </div>

                      </div>

                    </div>

                    {/* FOOTER */}

                    <div className="tpmodern-card-footer">

                      <button className="tpmodern-explore-btn">
                        Explore Project
                      </button>

                      <button className="tpmodern-view-btn">
                        View Details
                      </button>

                    </div>

                  </div>

                </div>

              </div>

            ))}

          </Slider>

        </div>

      </div>

    </section>
  );
};

export default NewTopProject;